import { render, staticRenderFns } from "./main-setup.vue?vue&type=template&id=51c14ed9"
import script from "./main-setup.vue?vue&type=script&lang=js"
export * from "./main-setup.vue?vue&type=script&lang=js"
import style0 from "./main-setup.vue?vue&type=style&index=0&id=51c14ed9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports